export const Bitcoin = require("./Bitcoin.webp");
export const SpotifyConcept = require("./SpotifyConcept.webp");
export const Logitech = require("./Logitech.webp");
export const GPTArticles = require("./GPTArticles.webp");
